/* eslint-disable no-restricted-imports */
import {
  DocumentNode,
  OperationVariables,
  QueryHookOptions,
  TypedDocumentNode,
  useQuery,
} from '@apollo/client';
import { useRumContext } from 'services/observability/datadog/RumComponentContext';
import { createErrorMonitor } from 'services/observability/utilities';

/**
 * Graphql Hook
 *
 * Wraps useQuery to parse network status and error values in response.
 * @param query GraphQL query statement
 * @param options Apollo useQuery options
 * @returns Response object
 */
export function useGraphql<
  QueryData = any,
  QueryVariables extends OperationVariables = OperationVariables,
>(
  query: DocumentNode | TypedDocumentNode<QueryData, QueryVariables>,
  options?: QueryHookOptions<QueryData, QueryVariables>,
) {
  const { teamName, productName } = useRumContext();
  const { data, networkStatus, previousData, error, refetch } = useQuery<QueryData, QueryVariables>(
    query,
    options,
  );
  createErrorMonitor({ name: 'GRAPHQL', teamName, productName })(error);

  return {
    data,
    previousData,
    error: Boolean(error),
    errorMessage: error,
    isLoading: networkStatus < 5, // https://github.com/apollographql/apollo-client/blob/d96f4578f89b933c281bb775a39503f6cdb59ee8/src/core/networkStatus.ts#L4
    /**
     * @deprecated This field should not be used, left to maintain existing usage when migrating off of useQuery
     */
    networkStatus,
    refetch,
  };
}
